import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantContextService } from 'src/core/services/tenant-context/tenant-context.service';
import { catchError, map, of } from 'rxjs';
import { ClientSessionService } from 'src/core/services/client-session/client-session.service';
import { AccessNoticeState } from 'src/utils/helpers/access-notice';
import { LegalAcceptanceService } from 'src/core/services/legal-acceptance/legal-acceptance.service';

export const legalAcceptanceGuard: CanActivateFn = (_route, state) => {
  const session = inject(ClientSessionService);
  const legalAcceptance = inject(LegalAcceptanceService);
  const router = inject(Router);
  const tenant = inject(TenantContextService);

  // Tras aceptar, el cliente vuelve a donde iba y con el aviso que traía.
  const goToLegalAcceptance = () =>
    router.navigate(['/legal-acceptance'], {
      queryParams: tenant.tenantParam(),
      state: {
        returnUrl: state.url,
        accessNotice: (router.getCurrentNavigation()?.extras.state as AccessNoticeState | undefined)?.accessNotice,
      },
    });

  const current = session.current;
  if (!current) {
    tenant.goToLogin();
    return of(false);
  }

  // La compuerta se evalúa una vez por sesión (REQ-FUNC-07): navegar entre
  // vistas no puede volver a bloquear a quien ya aceptó al entrar, ni siquiera
  // si el tenant publicó una versión nueva mientras tanto.
  return legalAcceptance.ensureAcceptedForSession(current.clientUserId).pipe(
    map((accepted) => {
      if (!accepted) {
        goToLegalAcceptance();
        return false;
      }
      return true;
    }),
    // Fail-closed: si no se puede verificar la aceptación, no se asume que está al día.
    catchError(() => {
      goToLegalAcceptance();
      return of(false);
    })
  );
};
